$(window).ready(function () {
    let instance = $('.instance-select');

    if (instance.length > 0) {

        getLanguagesByInstanceId(instance.val(), function (output) {

            let languageSelect = $('.language-select');
            languageSelect.find('option').remove();

            for (let keys in output) {
                languageSelect.append('<option selected value="' + keys + '">' + output[keys] + '</option>')
            }
        });

        instance.change(function () {
            getLanguagesByInstanceId(instance.val(), function (output) {

                let languageSelect = $('.language-select');
                languageSelect.find('option').remove();

                for (let keys in output) {
                    languageSelect.append('<option selected value="' + keys + '">' + output[keys] + '</option>')
                }
            });
        });
    }

   $('body').on('change', '.js-checkbox-enable-input[type="checkbox"]', function () {
	   let inputFieldCheckbox = $(this);
	   let inputGroupBox = inputFieldCheckbox.parents('.js-input-group-checkbox-enable');
	   let inputFieldValue = inputGroupBox.find('input[type="text"]');
	   if (inputFieldCheckbox.prop('checked')) {
		   inputFieldValue.removeAttr('disabled');
		   inputFieldValue.val(inputFieldValue.attr('data-value'));
		   inputFieldValue.attr('data-value', '');
	   } else {
		   inputFieldValue.attr('data-value', inputFieldValue.val());
		   inputFieldValue.prop('disabled', true);
		   inputFieldValue.val('');
	   }
   });

    let categorySelect = $('.category-select');

    if (categorySelect.length > 0) {
        getProductGroupsByCategoryId(categorySelect.val(), function (output) {

            let groupSelect = $('.group-select');

            groupSelect.empty();

            for (let keys in output) {
                groupSelect.append('<option selected value="' + keys + '">' + output[keys] + '</option>')
            }
        });


        categorySelect.change(function () {
            getProductGroupsByCategoryId(categorySelect.val(), function (output) {

                let groupSelect = $('.group-select');

                groupSelect.empty();

                for (let keys in output) {
                    groupSelect.append('<option selected value="' + keys + '">' + output[keys] + '</option>')
                }
            });
        });
    }

    let attributeKeySelect = $('.product-attribute-keys-select');

    if (attributeKeySelect.length > 0) {

        let values = attributeKeySelect.val();

        $.each(values, function (i, val) {
            let tableRow = $(`tr[data-attribute-key=${val}]`);
            tableRow.show();
        });

        attributeKeySelect.change(function () {
            let values = attributeKeySelect.val();

            $(`tr[data-attribute-key]`).hide();

            $.each(values, function (i, val) {
                let tableRow = $(`tr[data-attribute-key=${val}]`);
                tableRow.show();
            });
        });
    }

    if ($('.alert-callout-subtle').length > 0) {
        setTimeout(function () {
            $('.alert-callout-subtle').fadeOut('slow');
        }, 5000);
    }

    let sideMenu = $('#menu-showhide');

    if (sideMenu.length) {
        let parentListItems = sideMenu.children();
        parentListItems.each(function () {
            if ($(this).find('ul').children().length == 0) {
                $(this).hide();
            }
        })
    }
});


function getProductGroupsByCategoryId(id, callback) {
    $.ajax({
        url: '/ajax/getProductGroupsByCategoryId',
        type: 'post',
        data: {
            "data": id
        },
        success: function (data) {
            callback(data);
        }
    })
}

function getLanguagesByInstanceId(id, callback) {
    $.ajax({
        url: '/languages/getLanguageByInstance',
        type: 'post',
        data: {
            "data": id
        },
        success: function (data) {
            callback(data);
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/contentElements/dynamicContent.js